document.querySelector(".popup-btn-unsuccess").addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup-unsuccess").style.display = 'block';
}, false);

document.querySelector(".popup-btn-unsuccess").addEventListener('click', function () {
  document.querySelector(".popup-overlay-unsuccess").style.display = 'block';
}, false);

document.querySelector(".popup-close-unsuccess").addEventListener('click', function () {
  document.querySelector(".popup-unsuccess").style.display = 'none';
  document.querySelector(".popup-overlay-unsuccess").style.display = 'none';
}, false);

document.querySelector("body").addEventListener('click', function () {
  document.querySelector(".popup-unsuccess").style.display = 'none';
  document.querySelector(".popup-overlay-unsuccess").style.display = 'none';
}, false);

document.querySelector(".popup-unsuccess").addEventListener('click', function (e) {
  e.stopPropagation();
}, false);